import React from 'react';
import { useCreateContext, useEditContext } from 'react-admin';
import { PolicyEntities, PolicyOperations } from '../../shared/constants/policies';
import DisplayByPolicy from '../DisplayByPolicy';
import { AccessLevel } from '../../shared/utils/policyCheck';

export function useInputWithPolicies(
  Element: React.ReactElement,
  source: string,
  level?: AccessLevel,
  ignorePolicies?: boolean
) {
  // const createContext = useCreateContext();
  // const editContext = useEditContext();
  // if (ignorePolicies || (!createContext.resource && !editContext.resource))
  //   return Element;

  // let context;
  // let operation: PolicyOperations;
  // if (createContext.resource) {
  //   context = createContext;
  //   operation = PolicyOperations.CREATE;
  // }
  // if (editContext.resource) {
  //   context = editContext;
  //   operation = PolicyOperations.UPDATE;
  // }

  return (
    // <DisplayByPolicy
    //   id={context.resource?.toUpperCase() as PolicyEntities}
    //   action={operation}
    //   field={source}
    //   level={level}
    // >
    <>{Element}</>
    // </DisplayByPolicy>
  );
}
